// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "InlineNotification-module--bx--text-truncate--end--tLeJO";
export var bxTextTruncateFront = "InlineNotification-module--bx--text-truncate--front--wslvH";
export var darkMode = "InlineNotification-module--darkMode--ndD6-";
export var notification = "InlineNotification-module--notification--8Y+o8";